export default __webpack_public_path__ + "static/FuturaBT-Bold-4844513bbf79a57a2d65e34c791fc53d.woff";